export const expenseDetails = [
  {
    checkbox: true,
    expense_name: "Online Course",
    date:"14/01/2024",
    payment_method:"Cash",
    amount: "$3000",
    key: "1"
  },
  {
    checkbox: true,
    expense_name: "Travel",
    date:"20/02/2024",
    payment_method:"Cheque",
    amount: "$2800",
    key: "2"
  },
  {
    checkbox: true,
    expense_name: "Office Supplies",
    date:"15/03/2024",
    payment_method:"Cash",
    amount: "$3300",
    key: "3"
  },
  {
    checkbox: true,
    expense_name: "Welcome Kit",
    date:"12/04/2024",
    payment_method:"Cheque",
    amount: "$3600",
    key: "4"
  },
  {
    checkbox: true,
    expense_name: "Equipment",
    date:"20/05/2024",
    payment_method:"Cheque",
    amount: "$2000",
    key: "5"
  },
  {
    checkbox: true,
    expense_name: "Miscellaneous",
    date:"06/07/2024",
    payment_method:"Cash",
    amount: "$3400",
    key: "6"
  },
  {
    checkbox: true,
    expense_name: "Payroll",
    date:"02/09/2024",
    payment_method:"Cheque",
    amount: "$4000",
    key: "7"
  },
  {
    checkbox: true,
    expense_name: "Cafeteria",
    date:"15/11/2024",
    payment_method:"Cash",
    amount: "$4500",
    key: "8"
  },
  {
    checkbox: true,
    expense_name: "Cleaning Supplies",
    date:"10/12/2024",
    payment_method:"Cheque",
    amount: "$3800",
    key: "9"
  },

];
